import type { ContractSettingGetAllApiResult } from '@common/interfaces/api/contractSettingsApi';
import type { IContractSettingAddEditValidated } from '@common/validation/contractSetting';
import { nonNullable } from '@common/utils/nonNullableTypeUtils';
import { UrlBuilder } from '@common/utils/urlBuilder';
import { fetchJson } from '@frontend/store/fetch';

type GetArgs = {
    episodeCategoryId: string;
    organizationId: string;
};

export async function getAll({ episodeCategoryId, organizationId }: GetArgs, signal: AbortSignal) {
    const urlBuilder = new UrlBuilder('/api/contractSettings');

    urlBuilder.add('episodeCategoryId', episodeCategoryId);
    urlBuilder.add('organizationId', organizationId);

    const url = urlBuilder.build();
    const result = await fetchJson<ContractSettingGetAllApiResult>({ method: 'GET', signal, url });

    return nonNullable(result.json);
}

export async function updateAll(
    contractSettings: IContractSettingAddEditValidated[],
    signal: AbortSignal
): Promise<void> {
    const url = '/api/contractSettings/updateAll';
    const body = { contractSettings };

    await fetchJson({ body, method: 'POST', signal, url });
}
